<template>
  <el-dialog title="修改密码" :close-on-click-modal="false" :visible.sync="innerVisible" width="400px"
    v-loading.fullscreen.lock="fullscreenLoading">
    <zj-form :model="companyForm" :rules="companyRules" ref="companyForm" label-width="100px" size="small">
      <el-form-item label="组织类型" prop="orgnization">
        <el-radio v-model="companyForm.orgnization" label="school" @change="refreshCompanyData()">学校</el-radio>
        <el-radio v-model="companyForm.orgnization" label="company" @change="refreshCompanyData()">企业</el-radio>
      </el-form-item>
      <el-form-item prop="c_name" label="组织名称" v-if="showCompany">
        <el-select v-model="companyForm.c_name" placeholder="请选择或输入学校、组织" style="width: 250px" filterable
          :filter-method="loadCompany">
          <el-option v-for="item in companyDataShow" :key="item.code" :label="item.name" :value="item.name">
          </el-option>
        </el-select>
      </el-form-item>
      <div class="zj-form-bottom">
        <el-button size="small" @click="innerVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="onChangeClick">确认修改</el-button>
      </div>
    </zj-form>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fullscreenLoading: false,
      showCompany: false,
      companyDataShow: [],
      companyData: [],
      companyForm: {
        orgnization: "",
        c_name: "",
      },
      companyRules: {
        orgnization: [{ required: true, message: "请选择组织类型", trigger: "blur" }],
        c_name: [{ required: true, message: "请选择组织", trigger: "blur" }],
      }
    }
  },
  computed: {
    ...mapState(["accountInfo"]),
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    onChangeClick() {
      this.$refs.companyForm.validate(valid => {
        if (valid) {
          this.z_put("api/school/changeCompany", {}, {
            params: {
              c_name: this.companyForm.c_name,
              c_type: this.companyForm.orgnization,
              emp_id: this.accountInfo.emp_id,
              user_id: this.accountInfo.user_id,
            },
            loading: this.$refs.companyForm
          }
          ).then(res => {
            this.$alert("修改成功", "提示", {
              confirmButtonText: "确认",
              type: "success"
            }).then(_ => {
              this.fullscreenLoading = true;
              this.$refs.companyForm.resetFields();
              this.innerVisible = false;
              this.logout()
            })
              .catch(_ => {
              });
          }).catch(err => {
            this.$alert("修改失败！" + err.msg, "提示", {
              confirmButtonText: "确定",
              type: "error"
            });
          });
        }
      });
    },
    refreshCompanyData() {
      this.companyData = {}
      this.companyDataShow = {}
      this.z_get("api/school/companyData", { orgnization: this.companyForm.orgnization == "school" ? 0 : 1 }).then(res => {
        this.companyData = res.data;
        this.companyDataShow = this.companyData
        // this.companyDataShow = res.data.slice(0, 20);
        this.showCompany = true
      }).catch(res => { });

    },
    loadCompany(value) {
      let query = value;
      let arr = this.companyData.filter(item => {
        return item.name.includes(query);
      });
      this.companyDataShow = arr;
      // if (arr.length > 20) {
      //   this.companyDataShow = arr.slice(0, 20);
      // } else {
      //   this.companyDataShow = arr;
      // }
    },
    //退出登录
    logout() {
      this.z_post("access/api/home/logout").then(res => {
        window.location.href = `${window.location.origin}/login.html?t=${new Date().getTime().toString(16)}`;
        this.fullscreenLoading = false;
      }).catch(err => {
        console.log(err);
        window.location.href = `${window.location.origin}/login.html?t=${new Date().getTime().toString(16)}`;
        this.fullscreenLoading = false;
      });
    },
  }
}
</script>